import { courseList } from '../components/courses/course-list/course-list.store';
import { courseDetails } from '../components/courses/course-details/course-details.store';
import { classList } from '../components/classes/class-list/class-list.store';
import { consumerList } from '../components/consumers/consumer-list/consumer-list.store';
import { consumerDetails } from '../components/consumers/consumer-details/consumer-details.store';
import { consumerConfig } from '../components/courses/course-list/consumer-config/consumer-config.store';
import { tradeRuleList } from '../components/tradeRules/tradeRule-list/tradeRule-list.store';
import {tradeRule} from '../components/tradeRules/tradeRule-details/setupTradeRule.store';
import {reports} from '../components/reports/reports.store';
import {jobStatus} from '../components/jobStatus/jobstatus.store';
export const createStore = context => ({
  ...context.state,
  CourseList: courseList(context),
  CourseDetails: courseDetails(context),
  ConsumerConfig: consumerConfig(context),
  ClassList: classList(context),
  ConsumerList: consumerList(context),
  ConsumerDetails: consumerDetails(context),
  TradeRuleList: tradeRuleList(context),
  TradeRule: tradeRule(context),
  Reports: reports(context),
  JobStatus : jobStatus(context)
})
